import { operationSettingType, } from '@/constants/operationSetting/option';
export const isApplyConfigSurchargeFormData = (data, selectedType) => selectedType === operationSettingType.APPLY_IRREGULAR_SURCHARGE;
export const isDeliveryStatusFormData = (data, selectedType) => selectedType === operationSettingType.DELIVERY_STATUS;
export const isIrregularSurchargeFormData = (data, selectedType) => selectedType === operationSettingType.IRREGULAR_SURCHARGE;
export const createOperationSettingFormData = () => ({});
